<template>
  <div class="dialog-container dialog-light help">
    <div class="help-dialog dialog dialog-md">
      <ax-dialog-header text="We're here to help!" :type="'help'"></ax-dialog-header>
      <div class="help-buttons mt-5 mb-3 btn-group d-flex justify-content-stretch">
        <a id="navbarWelcome" data-bs-toggle="help" class="btn btn-primary active" aria-current="page" @click="showWelcome()">Welcome</a>
        <a id="navbarCashSummary" data-bs-toggle="help" class="btn btn-primary" @click="showCashSummary()">Cash Summary</a>
        <a id="navbarProfitLoss" data-bs-toggle="help" class="btn btn-primary" @click="showProfitLoss()">Profit/Loss</a>
        <a id="navbarIncomeDrivers" data-bs-toggle="help" class="btn btn-primary" @click="showIncomeDrviers()">Income Drivers</a>
        <a id="navbarExpenseDrivers" data-bs-toggle="help" class="btn btn-primary" @click="showExpenseDrviers()">Expense Drivers</a>
        <a id="navbarWhatIf" data-bs-toggle="help" class="btn btn-primary" @click="showWhatIf()">What If</a>
      </div>
      <div class="dialog-body text-center">
        <div class="help-form">
          <span>{{ content }}</span>
          <div class="mt-5 pt-3">
            <div class="row justify-content-center">
              <div class="col-12 col-lg-4">
                <k-button
                  class="btn btn-lg btn-outline-primary w-100"
                  type="submit"
                  @click="close()"
                >Close</k-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import store from "../../store/index";
const toast = useToast();

export default {
  name: "help",
  props: {
    defaultTab: String
  },
  data: function () {
    return {
      activeTab: "Welcome",
      content: "",
      welcomeContent: "1 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt.",
      incomeDriversContent: "4 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt.",
      expenseDriversContent: "5 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt.",
      profitLossContent: "3 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt.",
      cashSummaryContent: "2 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt.",
      whatIfContent: "6 - Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam tristique pellentesque venenatis. Aenean tincidunt."
    }
  },
  async mounted() {
    switch(this.defaultTab) {
      case "Income Drivers":
        this.showIncomeDrviers();
        break;
      case "Expense Drivers":
        this.showExpenseDrviers();
        break;
      case "Profit / Loss":
        this.showProfitLoss();
        break;
      case "Cash Summary":
        this.showCashSummary();
        break;
      case "What If":
        this.showWhatIf();
        break;
      default:
        this.showWelcome();
    }
  },
  methods: {
    setActiveClass(id) {
      const activeButtons = document.querySelectorAll(".active");
      activeButtons.forEach(btn => {
        btn.classList.remove("active");
      });
      if (document.querySelector("#" + id)) {
        document.querySelector("#" + id).classList.add("active");
      }
    },
    showWelcome() {
      this.content = this.welcomeContent;
      this.activeTab = "Welcome";
      this.setActiveClass("navbarWelcome");
    },
    showIncomeDrviers() {
      this.content = this.incomeDriversContent;
      this.activeTab = "Income Drivers";
      this.setActiveClass("navbarIncomeDrivers");
    },
    showExpenseDrviers() {
      this.content = this.expenseDriversContent;
      this.activeTab = "Expense Drivers";
      this.setActiveClass("navbarExpenseDrivers");
    },
    showProfitLoss() {
      this.content = this.profitLossContent;
      this.activeTab = "Profit / Loss";
      this.setActiveClass("navbarProfitLoss");
    },
    showCashSummary() {
      this.content = this.cashSummaryContent;
      this.activeTab = "Cash Summary";
      this.setActiveClass("navbarCashSummary");
    },
    showWhatIf() {
      this.content = this.whatIfContent;
      this.activeTab = "What If";
      this.setActiveClass("navbarWhatIf");
    },
    showSuccess(msg) {
      toast.clear();
      toast.success(msg);
    },
    close() {
      this.$emit("closePopup");
    },
    showAlert() {
      toast.clear();
      toast.error("Something went wrong! Please try again.");
    }
  }
}
</script>
